import axios from "../../utils/axios";

//read transactions
export const getTransactions = async (searchType) => {
    let queryString = "";

    if (searchType && searchType !== "all") queryString += `type=${searchType}`;

    const response = await axios.get(`/transactions?${queryString}`);

    return response.data;
};

//create transaction
export const addTransaction = async (data) => {
    const response = await axios.post("/transactions", data);

    return response.data;
};

//update transaction
export const editTransaction = async (id, data) => {
    const response = await axios.put(`/transactions/${id}`, data);

    return response.data;
};

//delete transaction
export const deleteTransaction = async (id) => {
    const response = await axios.delete(`/transactions/${id}`);

    return response.data;
};
